<template>
  <ion-modal
    ref="modal"
    :isOpen="isOpen"
    trigger="{{trigger}}"
    :backdropDismiss="closeOnBackdropClick"
    class="GlassModal"
    :enter-animation="enterAnimation"
    :leave-animation="leaveAnimation"
  >
    <div class="GlassModalWrapper" :style="{ gap: gap + 'px' }">
      <!-- close row -->
      <div class="modalWrap" v-if="!hideHeader">
        <div class="addNewModalHeader" style="order: 1">
          <span>{{ title }}</span
          ><span class="subtitle-text">{{ truncate(subtitle, 40) }}</span>
        </div>
        <ion-buttons style="order: 2">
          <ion-button class="close-GlassModal" @click="closeModal()">
            <ion-icon slot="icon-only" :icon="closeOutline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </div>
      <!-- render content within GlassModal-->
      <slot></slot>
    </div>
    <div class="glass-div"></div>
  </ion-modal>
</template>

<script>
import {
  IonButton,
  IonButtons,
  createAnimation,
  IonIcon,
  IonModal,
  modalController,
} from '@ionic/vue';
import { closeOutline } from 'ionicons/icons';
export default {
  name: 'GlassModal',
  components: {
    IonButton,
    IonButtons,
    IonIcon,
    IonModal,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
    closeOnBackdropClick: {
      type: Boolean,
      default: true,
    },
    gap: {
      type: Number,
      default: 24,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const enterAnimation = (baseEl) => {
      const root = baseEl.shadowRoot;

      const backdropAnimation = createAnimation()
        .addElement(root.querySelector('ion-backdrop'))
        .fromTo('opacity', '0.01', 'var(--backdrop-opacity)');

      const wrapperAnimation = createAnimation()
        .addElement(root.querySelector('.modal-wrapper'))
        .keyframes([
          {
            offset: 0,
            transform: 'scale(0.98)',
          },
          {
            offset: 1,
            transform: 'scale(1)',
          },
        ]);

      return createAnimation()
        .addElement(baseEl)
        .easing('ease-out')
        .duration(250)
        .addAnimation([backdropAnimation, wrapperAnimation]);
    };

    const leaveAnimation = (baseEl) =>
      enterAnimation(baseEl).direction('reverse');

    return { enterAnimation, leaveAnimation };
  },
  methods: {
    closeModal() {
      modalController.dismiss();
    },
    truncate(words, maxLength) {
      if (words?.length <= maxLength) {
        return words;
      }
      return words?.slice(0, maxLength) + '...';
    },
  },
  data() {
    return {
      closeOutline,
    };
  },
};
</script>

<style scoped>
ion-modal.GlassModal {
  --width: fit-content;
  --height: fit-content;
  --box-shadow: 0 28px 48px rgba(0, 0, 0, 0.4);
  --background: transparent;
  --border-radius: 32px;
}
.glass-div {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: absolute;
  z-index: -2;
  backdrop-filter: blur(12px);
  border-radius: 32px;
}
ion-modal.GlassModal .GlassModalWrapper {
  display: inline-flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-end;
  --backdrop-opacity: 0.4;
  background: rgba(82, 82, 91, 0.5);
  border: 1px solid var(--ion-border-primary, rgba(255, 255, 255, 0.1));
  border-radius: 32px;
}

.modalWrap {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 32px;
}
.close-GlassModal {
  color: var(--ion-color-step-800);
}

.addNewModalHeader {
  color: var(----ion-color-step-800, #f4f4f5);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
}

.subtitle-text {
  color: var(--ion-color-step-500);
  font-size: 15px;
  font-weight: 400;
  line-height: 16px;
}
</style>
